














import { Component, Vue } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";
import { fileOpen, fileDownload } from "@/file-utils";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import reportModel from "@/models/report.model";

@Component({
	components: {
		ShiftFilter,
		PaginatedSearch,
		Circle2,
	},
})
export default class ShiftsReport extends Vue {
	shiftModel: any;
	shiftFilter: Record<string, any> = {};
	shiftId: any = null;
	fileDownloading = false;

	constructor() {
		super();
	}

	updateFilter(filter: any)  {
		this.shiftFilter = filter;
	}

	async getReport(kind: "DOWNLOAD" | "OPEN") {
		this.fileDownloading = true;
		try {
			const pdfBlob = await reportModel.getValidatedShiftsReport({
				sectorId: this.shiftFilter?.sector,
				specialtyId: this.shiftFilter['sector.specialty'],
				startDateTime: this.shiftFilter.startDateTime,
				professionalUserId: this.shiftFilter?.professionalUser,
				unitId: this.shiftFilter.unit
			});
			if (kind === "DOWNLOAD") {
				fileDownload(pdfBlob, 'prestacao-contas.xlsx');
			}
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		}
		this.fileDownloading = false;
	}
}
